import { gql } from '@apollo/client'

export const GET_DRIVER_IQ_UDF_FIELDS = gql`
  query GetDriverIQUdfFields {
    driverIQUdfFields {
      driverIQUdfFieldId
      slot
      label
      isRequired
      sortOrder
      options {
        driverIQUdfFieldOptionId
        label
        value
        sortOrder
      }
    }
  }
`

export const SAVE_DRIVER_IQ_UDF_FIELDS = gql`
  mutation SaveDriverIQUdfFields($input: SaveDriverIQUdfFieldsInput!) {
    saveDriverIQUdfFields(input: $input) {
      driverIQUdfFieldId
      slot
      label
      isRequired
      sortOrder
      options {
        driverIQUdfFieldOptionId
        label
        value
        sortOrder
      }
    }
  }
`
